import React from 'react';
import { Img } from 'react-image';
import { Button } from 'flowbite-react';
import { AiOutlineCalendar } from 'react-icons/ai';
import { useUserContext } from 'src/context/UserProvider';
import { CurrentWorkingStatus } from 'types';

interface Props {
	onClick: () => void;
}

const NoRoundScheduled = ({ onClick }: Props) => {
	const { hasActiveMeeting, user, isScreeningRoundInCompleted } = useUserContext();

	// only return true if user has not completed screening round and is not a masai student
	const shouldDisableInterviewBooking = user?.flags.isMasaiStudent ? false : !!isScreeningRoundInCompleted;
	return (
		<>
			<div className="flex flex-col items-center justify-center">
				<div className="px-8">
					<div className="flex justify-center">
						<Img
							loading="lazy"
							src="/assets/noApplicationsEmptyState.svg"
							alt="noApplicationsEmptyState"
							width="160"
							height="160"
						/>
					</div>

					<div className="text-center mt-4 text-base font-medium">No round scheduled</div>
					<div className="text-center mt-2 text-sm font-normal dark:text-[#C7C9D9] text-gray-500">
						Discover your level, insights and unlock opportunities.
					</div>

					{/* <div className="flex justify-center mt-5">
						<Button color="purplePlaced" disabled={hasActiveMeeting || shouldDisableInterviewBooking} onClick={onClick}>
							<AiOutlineCalendar className="mr-2" />
							Know Your Level
						</Button>
					</div> */}
				</div>
			</div>
		</>
	);
};

export default NoRoundScheduled;
